/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Registry_Cee_LinkInputs */

const cs_property_registry_cee_link = /** @type {(inputs: Property_Registry_Cee_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otevřít CEE (ceecr.cz)`)
};

const en_property_registry_cee_link = /** @type {(inputs: Property_Registry_Cee_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open CEE (ceecr.cz)`)
};

/**
* | output |
* | --- |
* | "Open CEE (ceecr.cz)" |
*
* @param {Property_Registry_Cee_LinkInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_registry_cee_link = /** @type {((inputs?: Property_Registry_Cee_LinkInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Registry_Cee_LinkInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_registry_cee_link(inputs)
	return cs_property_registry_cee_link(inputs)
});